import React from 'react';

import { IDummyProps } from './types';
import { Card } from 'baseui/card';
import { styled } from '../../Themes';

import { overrides as customOverrides } from './overrides';
import { mergeOverrides } from 'baseui';

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const {
		headerEllipsis,
		overrides,
		hideHeader,
		expanded,
		headerBackground,
		hideSeparator,
		contentStyles,
		contentProps,
		...rest
	} = props;
	return (
		<Card
			{...rest}
			title={true}
			overrides={
				overrides ? mergeOverrides(customOverrides(props, ref), overrides as any) : customOverrides(props, ref)
			}
		>
			{props.children}
		</Card>
	);
});

export const CardFooter = styled('div', ({ $theme }: any) => {
	return {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: 'var(--epods--space-inset-m)',
		width: '100%',
	};
});
